.title-menu {
  font-family: 'Inter';
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: space-between;
  font-size: 0.875rem;
  font-weight: 400;
  white-space: nowrap;
}

.menu-option {
  color: #333;
  text-decoration: none;
}

.submenu-item {
  visibility: hidden;
  list-style: none;
  margin-left: 1rem;
  border-left-style: solid;
  border: none;
  opacity: 0;
  max-height: 0;
  transition: all 0.5s ease;

  background-color: #f4f4f8;
}

.sub-submenu-item {
  visibility: hidden;
  list-style: none;
  margin-left: 1rem;
  border-left-style: solid;
  border: none;
  opacity: 0;
  max-height: 0;
  transition: all 0.5s ease;

  background-color: #f4f4f8;
}

.menu-item {
  border-left: 2px solid #b4b4cf;
}

a {
  cursor: pointer;
}

ul {
  list-style: none;
  padding: 0;
  margin: 0;
}

.menu.open .submenu-item {
  visibility: visible;

  max-height: 100%;
  opacity: 1;
  transition: opacity 0.5s ease-in;
  transition: max-height 0.5s;
  margin-top: 0.5rem;
  padding-bottom: 0.5rem;
}

.submenu-item .menu-item.open .sub-submenu-item {
  visibility: visible;

  max-height: 100%;
  opacity: 1;
  transition: opacity 0.5s ease-in;
  transition: max-height 0.5s;
  margin-top: 0.5rem;
  padding-bottom: 0.5rem;
}

.submenu-item .menu-item.open .icon-more {
  display: none;
}

.submenu-item .menu-item.open .icon-less {
  display: flex;
}

.submenu-item .menu-item .icon-less {
  display: none;
}

.submenu-item .menu-item .icon-more {
  display: flex;
}

.menu-option {
  display: flex;
  align-items: center;
  gap: 1rem;
  border: none;
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
  padding-inline: 1rem;
}

.menu-item {
  padding: 0rem;
}

.menu-item {
  background-color: #f4f4f8;
}

.menu-option.active {
  color: #00c49a;
  border-right: 4px solid #00c49a;
}

.menu-option.active .title-menu {
  font-weight: 700;
}

.menu-item.active .submenu-item {
  display: block;
  height: 100%;
  opacity: 1;
}

.menu-option:hover {
  background-color: #e6e6ef;
}
